$ = jQuery.noConflict();

// DOM READY
$(function () {
	// Utils

	// NE PAS MODIFIER //

// Récupération de l'url courante
	var currentURL         = window.location.href;

// utilisation des transitions de page via TweenMax
	var showLoader         = null;
	var hideLoader         = null;

// Définition de la fonction principale du site
	var pageInit           = null;

// END NE PAS MODIFIER //


// VARIABLES MODIFIABLES //

// Passer à TRUE si vous souhaitez utiliser les transitions showLoader et hideLoader
	var pageTransition = false;

// Passer à true si vous souhaitez utiliser les transition Ajax via BarbaJs
	var pageAjax = false;

// // Définition du breakpoint d'initialisation des effets parallax
// 	var parallaxBreakpoint = 768;


	initDocEvents();
	initLinks();
	initLoader();
	initMatchHeight();
	// initFitvids();

	// Components
	initActivityDetails();
	initActivityFilter();
	initButtons();
	initCarouselActFor();
	initContact();
	initHome();
	initLazyload();
	initNavToggle();
	initScrollImg();
	initParallax();
	resizeParallax();
	initParallaxHome();
	initPlanningMobile();
	initScrollAnimations();
	initScrollTransform();
	initSlick();
	new BlockCollapse();
	new BlockGallery();
	new BlockListingAppart();
	new NavScrolled();

	// getPageYScroll();
	// lastScroll = docScroll;
	// new SmoothScroll();
});
// END DO READY

function resizeHandler() {
	matchHeightReset();
}

function scrollHandler() {
	var scrollTop = $(window).scrollTop();

	if ( scrollTop > 100 ) {
		$('body').addClass('is_scrolled');
	}
	else {
		$('body').removeClass('is_scrolled');
	}
}

